// extracted by mini-css-extract-plugin
export default {"SlateWrapper":"TextAreaEditor_SlateWrapper__Zg0RY","SlateWrapper_Focused":"TextAreaEditor_SlateWrapper_Focused__G5zGQ","EditorWrapper2":"TextAreaEditor_EditorWrapper2__lRrUZ"};